// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonShortFieldLabels = {
  code: "コード",
  identifier: "識別子",
  name: "名称",
  description: "説明",
  createdBy: "作成者",
  createdAt: "作成日時",
  updatedBy: "更新者",
  updatedAt: "更新日時",
} as const;

export const commonShortNouns = {
  status: "状態",
  actions: "操作",
} as const;
